// extracted by mini-css-extract-plugin
module.exports = {"companyTitle":"styles_companyTitle__2Y2vW"};